import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { styled } from "styled-components";
import { BreadcrumbComponent } from "../../components/elements/Breadcrumb";
import { Divider, Grid, IconButton, Stack } from "@mui/material";
import { ImageViewer } from "../../components/image/ImageViewer";
import { Button, Skeleton } from "antd";
import { currencyFormatter } from "../../utils/formatter";
import { useFirebase } from "../../hooks/firebase/useFirebase";
import { sProducts, sUnavailable } from "../../constants/strings";
import { ArrowBack } from "@mui/icons-material";
import { OrderStatus, PaymentStatus, PaymentType } from "../../hooks/useOrders";
import { TelLink } from "../../components/common/Common";
import { db, functions, httpsCall } from "../../firebase/firebase";
import { doc } from "firebase/firestore";

export const ProductItem = ({ data }) => {
  const getShopDetails = httpsCall(functions, "getShopDetails");
  const [shopData, setShopData] = useState();

  const { qty, pid } = data;
  const { getDocData: getProduct, data: productData } = useFirebase();

  const { product_name, price, imageUrls = [], shop } = productData;

  useEffect(() => {
    getProduct(`${sProducts}/${pid}`);
  }, [pid]);

  useEffect(() => {
    if (shop) getShopData();
  }, [shop]);

  // const { getDocData: getShop, data: shopData, loadingShop } = useFirebase();
  // const { shop_name } = shopData;
  // useEffect(() => {
  //   getShop(`${sShops}/${shop}`);
  // }, [shop]);

  function getShopData() {
    getShopDetails({ shop_id: shop }).then((result) =>
      setShopData(result.data)
    );
  }

  return (
    <ProductWrapper className="radius8 flexSpaceCenter">
      <div className="flexNullCenter gap20">
        <ImageViewer width={70} url={imageUrls[0]} />
        <Stack spacing={1}>
          <p>{product_name}</p>
          {/* shop section */}
          <Skeleton
            active
            loading={!shopData?.shop_name}
            paragraph={{ rows: 0 }}
            children={
              <div className="flexCenter">
                <p className="lightColor font12">{shopData?.shop_name}</p>
                <VerticalDivider />
                <TelLink className="font12" phone={shopData?.phone} />
              </div>
            }
          />
        </Stack>
      </div>

      <Stack spacing={1} textAlign="right">
        <p style={{ fontSize: 17 }} className="bold">
          {currencyFormatter(price)}
        </p>
        <p className="lightColor font12">Qty: {qty}</p>
      </Stack>
    </ProductWrapper>
  );
};

export const OrderDetails = () => {
  const { loading, updateData } = useFirebase();
  const location = useLocation();
  const orderData = location?.state?.orderData;
  const {
    id,
    products,
    timestamp,
    amount,
    del_fee,
    payment_status,
    payment_type,
    order_status,
    address,
    read,
    delivered_on,
  } = orderData;

  const breadcrumbs = [
    {
      title: "Orders",
      href: "./",
    },
    {
      title: `ID ${id}`,
    },
  ];
  // console.log(orderData);

  useEffect(() => {
    if (read === 1) {
      updateData(doc(db, "orders", id), { read: 0 }, false);
    }
  }, [read]);

  return (
    <Wrapper className="whiteBg radius6">
      <div className="flexNullCenter gap20">
        <Link to={-1}>
          <IconButton>
            <ArrowBack />
          </IconButton>
        </Link>

        <BreadcrumbComponent items={breadcrumbs} />
      </div>

      {/* SECTION A - TITLE */}
      <Stack
        direction="row"
        gap={1}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <div className="flexCenter gap10">
          <h2>Order ID: {id}</h2> <OrderStatus status={order_status} />
        </div>

        <Button type="default">Invoice</Button>
      </Stack>
      <p className="font13">
        <span className="lightColor">Order Date:</span> {timestamp}
        <VerticalDivider />
        <span className="mainColor thin">Delivery Date: {delivered_on}</span>
      </p>
      <Divider sx={{ my: 3 }} />

      {/* SECTION B - PRODCUTS */}
      <Stack spacing={2}>
        {products.map((product, i) => (
          <ProductItem data={product} key={i} />
        ))}
      </Stack>

      <Divider sx={{ my: 3 }} />
      {/* SECTION C - PAYMENTS*/}
      <Grid container spacing={2} direction={{ xs: "column", sm: "row" }}>
        <Grid item xs={6}>
          <h3>Payment</h3>
          <br />
          <Stack spacing={1}>
            <p className="lightColor font12 thin">Payment Status</p>
            <div>
              <PaymentStatus status={payment_status} />
            </div>
          </Stack>
          <br />

          <Stack spacing={1}>
            <p className="lightColor font12 thin">Mode of Payment</p>
            <div>
              <PaymentType status={payment_type} />
            </div>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <h3>Delivery</h3>
          <br />
          <Stack spacing={1}>
            <p className="lightColor font12 thin">Address</p>
            <p style={{ lineHeight: 1.5 }}>
              {address?.region || sUnavailable},
              <br />
              {address?.street || sUnavailable}
              <br />
              {address?.additional_info}
            </p>
            <br />
            <p className="lightColor font12 thin">Customer Details</p>
            <p>
              {address?.full_name || sUnavailable}
              <VerticalDivider />
              {address?.phone ? (
                <TelLink phone={address?.phone} />
              ) : (
                sUnavailable
              )}
            </p>
          </Stack>
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      {/* SECTION D - SUMMARY*/}
      <Grid container spacing={2} direction={{ xs: "column", sm: "row" }}>
        {/* OTHER */}
        <Grid item xs={6}>
          <h3>Other Options</h3>
        </Grid>
        {/* Order Summary */}
        <Grid item xs={6}>
          <h3>Order Summary</h3>
          <br />
          <Stack spacing={2}>
            <Stack
              spacing={1}
              justifyContent={"space-between"}
              direction={"row"}
            >
              <Stack spacing={1} className="thin">
                <p>Subtotal</p>
                <p>Delivery</p>
              </Stack>
              <Stack spacing={1} className="lightColor thin" textAlign={"end"}>
                <p>{currencyFormatter(amount - del_fee)}</p>
                <p>{currencyFormatter(del_fee)}</p>
              </Stack>
            </Stack>
            <Divider sx={{ my: 3 }} />
            {/* Total */}
            <Stack
              spacing={1}
              justifyContent={"space-between"}
              direction={"row"}
            >
              <p>Total</p>
              <b>{currencyFormatter(amount)}</b>
            </Stack>
            <div />
          </Stack>
        </Grid>
      </Grid>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 20px;
  width: 50%;
  @media (max-width: 860px) {
    width: 100%;
  }
`;

const ProductWrapper = styled.div`
  padding: 15px;
  border: 1px solid #ddd;
`;

export const VerticalDivider = styled.span`
  height: 100%;
  min-height: 15px;
  width: 1px;
  display: inline-block;
  margin: 0 10px;
  border-right: 1px solid #ddd;
  margin-bottom: -3px;
`;
